export const formatCurrency = (value) => new Intl.NumberFormat('en-KE', {
  style: 'currency',
  currency: 'KES',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
}).format(Number(value || 0));

export const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString('en-KE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('en-KE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const rangeLabels = {
  week: 'Current week',
  month: 'Current month',
  year: 'Current year',
  all_time: 'All time'
};

export const escapeCsv = (value) => {
  const text = value === null || value === undefined ? '' : String(value);
  if (/["\n,]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};

export const buildCsv = (headers, rows) => {
  const lines = [];
  lines.push(headers.map((header) => escapeCsv(header)).join(','));
  rows.forEach((row) => {
    lines.push(row.map((cell) => escapeCsv(cell)).join(','));
  });
  return lines.join('\n');
};

export const downloadTextFile = (content, filename, mimeType = 'text/plain;charset=utf-8') => {
  const blob = new Blob([content], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadCsv = (headers, rows, filename) => {
  downloadTextFile(buildCsv(headers, rows), filename, 'text/csv;charset=utf-8');
};
